import React from 'react';
import {
  ApButtonGroup,
  ApButtonMain,
  ApButtonSecondary,
} from '@alixpartners/ui-components';
import { StyledModal } from './DateSwitchModal.styles';

interface IProps {
  isInvalid?: boolean;
  onSwitch(): void;
  onSave(): void;
  onClose(): void;
  isOpen: boolean;
}

export const DateSwitchModal: React.FC<IProps> = ({
  isInvalid,
  onSwitch,
  onSave,
  onClose,
  isOpen,
}) => {
  return (
    <StyledModal
      isOpen={isOpen}
      hasClosed={onClose}
      footer={({ handleClose }) => {
        return (
          <ApButtonGroup justifyContent="flex-end">
            <ApButtonSecondary onClick={handleClose}>Cancel</ApButtonSecondary>
            <ApButtonSecondary onClick={onSwitch}>
              Switch without saving
            </ApButtonSecondary>
            <ApButtonMain disabled={!!isInvalid} onClick={onSave}>
              Save and switch
            </ApButtonMain>
          </ApButtonGroup>
        );
      }}
    >
      There is unsaved allocation data for the current time period. Do you want
      to save it before switching to another time period?
    </StyledModal>
  );
};
